class MooMennSavedUtils {
  static key = 'moomenn:saved-products:v1';
  static limit = 100;
  static product(value, origin) {
    if (!value || typeof value.id !== 'string' || !/^[1-9]\d{0,19}$/.test(value.id) || typeof value.url !== 'string') return null;
    try {
      const url = new URL(value.url, origin);
      if (url.origin !== origin || url.username || url.password) return null;
      const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/]+)\/?$/i);
      if (!match || /%2f|%5c|\s|\\/i.test(match[1])) return null;
      return { id: value.id, url: '/products/' + match[1] };
    } catch (_) { return null; }
  }
  static decode(raw, origin) {
    try {
      const data = JSON.parse(raw);
      if (data?.version !== 1 || !Array.isArray(data.items)) return [];
      const unique = new Set();
      return data.items.slice(0, 1000).map((item) => this.product(item, origin)).filter((item) => {
        if (!item || unique.has(item.id) || unique.size >= this.limit) return false;
        unique.add(item.id);
        return true;
      });
    } catch (_) { return []; }
  }
  static requestURL(item, origin, root, current) {
    const product = this.product(item, origin);
    if (!product) return null;
    const safeRoot = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(root) ? root : '/';
    const url = new URL(safeRoot.replace(/\/$/, '') + product.url, origin);
    const context = new URL(current, origin);
    ['preview_theme_id', 'mm_stay_us', 'mm_stay_uk'].forEach((name) => {
      const value = context.searchParams.get(name);
      if (value && /^\d+$/.test(value)) url.searchParams.set(name, value);
    });
    url.searchParams.set('section_id', 'moomenn-saved-card');
    return url;
  }
  static retryDelay(value, now = Date.now()) {
    if (!value) return 0;
    const seconds = /^\d+$/.test(value) ? Number(value) * 1000 : Date.parse(value) - now;
    return Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
  }
  static storageState(host, origin, allowLocal = true) {
    let sessionPreferred = false;
    try { sessionPreferred = host.sessionStorage.getItem(this.key + ':session') === '1'; } catch (_) {}
    for (const name of allowLocal && !sessionPreferred ? ['localStorage', 'sessionStorage'] : ['sessionStorage']) {
      try {
        const storage = host[name];
        const items = this.decode(storage.getItem(this.key), origin);
        storage.setItem(this.key + ':probe', '1');
        storage.removeItem(this.key + ':probe');
        return { storage, items, mode: name === 'localStorage' ? 'local' : 'session' };
      } catch (_) {}
    }
    return { storage: null, items: [], mode: 'page' };
  }
  static save(state, items, host, origin) {
    if (!state.storage) return state;
    const value = JSON.stringify({ version: 1, items });
    const write = (target) => {
      if (!target.storage) return;
      if (target.mode === 'session') target.storage.setItem(this.key + ':session', '1');
      target.storage.setItem(this.key, value);
    };
    try { write(state); return state; }
    catch (_) {
      const fallback = state.mode === 'local' ? this.storageState(host, origin, false) : { storage: null, mode: 'page' };
      try { write(fallback); return fallback; }
      catch (_) { return { storage: null, mode: 'page' }; }
    }
  }
}

if (typeof module !== 'undefined' && module.exports) module.exports = MooMennSavedUtils;

(() => {
  if (typeof document === 'undefined' || window.MooMennSaved) return;
  const config = document.getElementById('MooMennSavedStrings');
  if (!config) return;
  let strings;
  try { strings = JSON.parse(config.textContent); } catch (_) { return; }
  const utils = MooMennSavedUtils;
  const origin = location.origin;
  let persistence = utils.storageState(window, origin);
  let items = persistence.items;
  const page = document.querySelector('[data-mm-saved-page]');
  const grid = page?.querySelector('[data-mm-saved-grid]');
  const heading = page?.querySelector('h1');
  const status = document.querySelector('[data-mm-saved-status]');
  const pageSize = 12;
  let currentPage = 1;
  let generation = 0;
  let announcement = 0;
  const cache = new Map();
  const requests = new Set();
  let focusItem = null;
  let focusHeading = false;

  function announce(message) {
    if (!status) return;
    clearTimeout(announcement);
    status.textContent = '';
    announcement = setTimeout(() => { status.textContent = message; }, 40);
  }
  function message(key) {
    return strings[key] + (persistence.mode === 'local' ? '' : ' ' + (persistence.mode === 'session' ? strings.sessionNote : strings.pageNote));
  }
  function persist() {
    persistence = utils.save(persistence, items, window, origin);
  }
  function syncButtons(root = document) {
    const selected = new Set(items.map((item) => item.id));
    const buttons = [...root.querySelectorAll('[data-mm-save]')];
    if (root.matches?.('[data-mm-save]')) buttons.push(root);
    buttons.forEach((button) => {
      const valid = utils.product({ id: button.dataset.productId, url: button.dataset.productUrl }, origin);
      if (!valid) return;
      const saved = selected.has(valid.id);
      const pressed = String(saved);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      const label = saved ? button.dataset.removeLabel : button.dataset.saveLabel;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.disabled) button.disabled = false;
      const text = button.querySelector('[data-mm-save-text]');
      const value = saved ? strings.saved : strings.save;
      if (text && text.textContent !== value) text.textContent = value;
    });
    document.querySelectorAll('[data-mm-saved-link]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), origin);
      const current = new URL(location.href);
      ['preview_theme_id', 'mm_stay_us', 'mm_stay_uk'].forEach((name) => {
        const value = current.searchParams.get(name);
        if (value && /^\d+$/.test(value)) url.searchParams.set(name, value);
      });
      if (link.href !== url.href) link.href = url.href;
      const label = strings.title + ': ' + items.length;
      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      const count = link.querySelector('[data-mm-saved-count]');
      if (count) {
        if (count.textContent !== String(items.length)) count.textContent = items.length;
        count.hidden = items.length === 0;
      }
    });
    page?.querySelectorAll('[data-mm-saved-session]').forEach((notice) => {
      notice.hidden = persistence.mode === 'local';
      const text = persistence.mode === 'page' ? strings.pageNote : strings.sessionNote;
      if (notice.textContent !== text) notice.textContent = text;
    });
  }
  function remove(id) {
    const index = items.findIndex((item) => item.id === id);
    if (index < 0) return;
    const active = document.activeElement;
    if (page?.contains(active)) {
      focusItem = items[index + 1]?.id || items[index - 1]?.id || null;
      focusHeading = !focusItem;
    }
    items = items.filter((item) => item.id !== id);
    cache.delete(id);
    persist();
    syncButtons();
    render();
    announce(message('removed'));
  }
  function placeholder(item) {
    const node = document.createElement('div');
    node.dataset.mmSavedEntry = item.id;
    node.className = 'mm-saved-placeholder';
    const text = document.createElement('span');
    text.textContent = strings.loading;
    node.append(text);
    return node;
  }
  function errorCard(item, error) {
    const node = document.createElement('div');
    node.dataset.mmSavedEntry = item.id;
    node.className = 'mm-saved-error';
    const text = document.createElement('p');
    text.textContent = error.unavailable ? strings.unavailable : strings.error;
    node.append(text);
    if (!error.unavailable) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'btn btn--secondary';
      retry.dataset.mmSavedRetry = item.id;
      retry.textContent = strings.retry;
      node.append(retry);
    }
    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'btn btn--secondary';
    removeButton.dataset.mmSavedRemove = item.id;
    removeButton.textContent = strings.remove;
    node.append(removeButton);
    return node;
  }
  async function fetchCard(item, controller) {
    const url = utils.requestURL(item, origin, strings.root, location.href);
    if (!url) throw { unavailable: true };
    let timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (response.status === 404 || response.status === 410) throw { unavailable: true };
      if (!response.ok) throw { retryAt: Date.now() + utils.retryDelay(response.headers.get('Retry-After')) };
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const template = parsed.querySelector('template[data-mm-saved-card]');
      if (!template || template.dataset.productId !== item.id) throw { unavailable: true };
      const node = template.content.querySelector('[data-mm-saved-entry]');
      if (!node || node.dataset.mmSavedEntry !== item.id || !node.querySelector('.product-card')) throw { unavailable: true };
      node.querySelectorAll('script').forEach((script) => script.remove());
      node.querySelectorAll('a[href]').forEach((link) => {
        const target = new URL(link.getAttribute('href'), origin);
        if (target.origin !== origin) return;
        ['preview_theme_id', 'mm_stay_us', 'mm_stay_uk'].forEach((name) => {
          const value = new URL(location.href).searchParams.get(name);
          if (value && /^\d+$/.test(value)) target.searchParams.set(name, value);
        });
        link.href = target.href;
      });
      return document.importNode(node, true);
    } finally { clearTimeout(timeout); }
  }
  let reviewScriptRequested = false;
  function loadSavedReviewBadges() {
    if (!grid?.querySelector('.jdgm-preview-badge')) return;
    const provider = window.jdgm;
    if (reviewScriptRequested || typeof provider?.customizeBadges === 'function') return;
    if (typeof provider?.batchRenderBadges !== 'function' || typeof provider?.loadScript !== 'function') return;
    reviewScriptRequested = true;
    provider.loadScript('widget/main.js');
  }
  document.addEventListener('jdgm.finishLoadingCore', loadSavedReviewBadges);

  function place(node, item, token) {
    if (token !== generation || !items.some((saved) => saved.id === item.id)) return;
    const existing = [...grid.children].find((child) => child.dataset.mmSavedEntry === item.id);
    if (existing && existing !== node) existing.replaceWith(node);
    syncButtons(node);
    loadSavedReviewBadges();
  }
  function restoreFocus() {
    if (focusHeading) {
      heading?.focus({ preventScroll: true });
      focusHeading = false;
    } else if (focusItem) {
      const node = [...grid.children].find((child) => child.dataset.mmSavedEntry === focusItem);
      const control = node?.querySelector('[data-mm-save], [data-mm-saved-remove]');
      if (control) {
        control.focus({ preventScroll: true });
        focusItem = null;
      }
    }
  }
  async function render() {
    if (!page || !grid) return;
    const token = ++generation;
    requests.forEach((controller) => controller.abort());
    requests.clear();
    const pages = Math.max(1, Math.ceil(items.length / pageSize));
    currentPage = Math.max(1, Math.min(pages, currentPage));
    const visible = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    const visibleIds = new Set(visible.map((item) => item.id));
    [...grid.children].forEach((node) => { if (!visibleIds.has(node.dataset.mmSavedEntry)) node.remove(); });
    page.querySelector('[data-mm-saved-empty]').hidden = items.length > 0;
    page.querySelector('[data-mm-saved-clear]').hidden = items.length === 0;
    page.querySelector('[data-mm-saved-total]').textContent = strings.count.replace('__COUNT__', items.length);
    const pagination = page.querySelector('[data-mm-saved-pagination]');
    pagination.hidden = pages === 1;
    page.querySelector('[data-mm-saved-page-label]').textContent = strings.page.replace('__PAGE__', currentPage).replace('__PAGES__', pages);
    pagination.querySelector('[data-mm-saved-page-step="-1"]').disabled = currentPage === 1;
    pagination.querySelector('[data-mm-saved-page-step="1"]').disabled = currentPage === pages;
    const queue = [];
    visible.forEach((item, index) => {
      let node = cache.get(item.id)?.node;
      if (!node) {
        node = placeholder(item);
        queue.push(item);
      }
      const existing = [...grid.children].find((child) => child.dataset.mmSavedEntry === item.id);
      if (existing && existing !== node) existing.replaceWith(node);
      if (grid.children[index] !== node) grid.insertBefore(node, grid.children[index] || null);
    });
    grid.setAttribute('aria-busy', String(queue.length > 0));
    syncButtons();
    restoreFocus();
    async function worker() {
      while (queue.length && token === generation) {
        const item = queue.shift();
        const controller = new AbortController();
        requests.add(controller);
        try {
          const node = await fetchCard(item, controller);
          if (token !== generation) return;
          cache.set(item.id, { node });
          place(node, item, token);
        } catch (error) {
          if (token !== generation) return;
          const detail = { unavailable: Boolean(error?.unavailable), retryAt: error?.retryAt || 0 };
          const node = errorCard(item, detail);
          cache.set(item.id, { node, error: detail });
          place(node, item, token);
        } finally { requests.delete(controller); }
        restoreFocus();
      }
    }
    await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
    if (token === generation) {
      grid.setAttribute('aria-busy', 'false');
      if (focusItem) { focusItem = null; heading?.focus({ preventScroll: true }); }
      restoreFocus();
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mm-save], [data-mm-saved-remove], [data-mm-saved-retry], [data-mm-saved-clear], [data-mm-saved-page-step]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.hasAttribute('data-mm-save')) {
      const item = utils.product({ id: button.dataset.productId, url: button.dataset.productUrl }, origin);
      if (!item) return;
      if (items.some((saved) => saved.id === item.id)) { remove(item.id); return; }
      if (items.length >= utils.limit) { announce(strings.limit); return; }
      items.push(item);
      persist();
      syncButtons();
      render();
      announce(message('added'));
    } else if (button.dataset.mmSavedRemove) {
      remove(button.dataset.mmSavedRemove);
    } else if (button.dataset.mmSavedRetry) {
      const id = button.dataset.mmSavedRetry;
      if ((cache.get(id)?.error?.retryAt || 0) > Date.now()) { announce(strings.retryWait); return; }
      focusItem = id;
      cache.delete(id);
      render();
    } else if (button.hasAttribute('data-mm-saved-clear')) {
      items = [];
      cache.clear();
      persist();
      focusHeading = true;
      syncButtons();
      render();
      announce(message('cleared'));
    } else {
      currentPage += Number(button.dataset.mmSavedPageStep);
      focusHeading = true;
      render();
      heading?.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  }, true);
  const observer = new MutationObserver((changes) => {
    changes.forEach((change) => {
      change.addedNodes.forEach((node) => { if (node.nodeType === 1) syncButtons(node); });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', (event) => {
    if (persistence.mode !== 'local' || (event.key !== utils.key && event.key !== null)) return;
    items = utils.decode(event.newValue, origin);
    for (const id of cache.keys()) if (!items.some((item) => item.id === id)) cache.delete(id);
    syncButtons();
    render();
  });
  window.addEventListener('pagehide', () => { requests.forEach((controller) => controller.abort()); });
  window.MooMennSaved = Object.freeze({ get count() { return items.length; }, get persistent() { return persistence.mode === 'local'; } });
  syncButtons();
  render();
})();
